import React from 'react';
import styles from './styles.module.css';

export default () => {
    return (
        <div className={styles.nfLoader}></div>
    )
}